/* Looli Lab – liten körmiljö för sidornas mallar ({{ }}-hål, <sc-for>, händelser och refs). */
(function () {
  'use strict';
  var EVENTS = ['click', 'input', 'change', 'keydown', 'pointerdown', 'pointerup', 'submit'];

  function resolve(path, scope) {
    path = path.trim();
    var parts = path.split('.');
    var cur = scope;
    for (var i = 0; i < parts.length; i++) {
      if (cur == null) return undefined;
      cur = cur[parts[i]];
    }
    return cur;
  }
  var HOLE = /\{\{\s*([\w$.]+)\s*\}\}/g;
  function interp(str, scope) {
    return str.replace(HOLE, function (_, p) {
      var v = resolve(p, scope);
      if (v == null || typeof v === 'function') return '';
      return String(v);
    });
  }
  function single(str) {
    var m = /^\s*\{\{\s*([\w$.]+)\s*\}\}\s*$/.exec(str);
    return m ? m[1] : null;
  }

  function Mount(root, templateHTML, Comp) {
    this.root = root;
    var doc = new DOMParser().parseFromString('<body>' + templateHTML + '</body>', 'text/html');
    this.tpl = doc.body;
    this.handlers = {};
    this.refs = {};
    this.refDone = new WeakMap();
    this.seq = 0;
    var self = this;
    var inst = new Comp();
    inst.props = inst.props || {};
    if (inst.state === undefined) inst.state = null;
    inst.setState = function (patch) {
      var prev = inst.state;
      var p = typeof patch === 'function' ? patch(prev, inst.props) : patch;
      inst.state = Object.assign({}, prev || {}, p || {});
      self.schedule(prev);
    };
    inst.forceUpdate = function () { self.schedule(inst.state); };
    this.inst = inst;
    EVENTS.forEach(function (type) {
      root.addEventListener(type, function (ev) {
        var el = ev.target;
        while (el && el !== root.parentNode) {
          if (el.nodeType === 1 && el.hasAttribute('data-dc-on-' + type)) {
            var fn = self.handlers[el.getAttribute('data-dc-on-' + type)];
            if (fn) fn(ev);
            return;
          }
          el = el.parentNode;
        }
      }, type === 'click' ? false : true);
    });
    this.render();
    if (typeof inst.componentDidMount === 'function') inst.componentDidMount();
  }

  Mount.prototype.schedule = function (prevState) {
    var self = this;
    if (this.pending) return;
    this.pending = true;
    this.prevForUpdate = prevState;
    Promise.resolve().then(function () {
      self.pending = false;
      self.render();
      if (typeof self.inst.componentDidUpdate === 'function') {
        try { self.inst.componentDidUpdate(self.inst.props, self.prevForUpdate); } catch (e) { console.error(e); }
      }
    });
  };

  Mount.prototype.buildNode = function (node, scope, out) {
    var self = this;
    if (node.nodeType === 3) { out.appendChild(document.createTextNode(interp(node.nodeValue, scope))); return; }
    if (node.nodeType !== 1) return;
    var tag = node.tagName.toLowerCase();
    if (tag === 'sc-for') {
      var list = resolve((single(node.getAttribute('list') || '') || ''), scope) || [];
      var as = node.getAttribute('as') || 'item';
      for (var i = 0; i < list.length; i++) {
        var s2 = Object.create(scope); s2[as] = list[i];
        for (var c = node.firstChild; c; c = c.nextSibling) self.buildNode(c, s2, out);
      }
      return;
    }
    var ns = node.namespaceURI;
    var el = (ns && ns !== 'http://www.w3.org/1999/xhtml') ? document.createElementNS(ns, node.localName) : document.createElement(tag);
    for (var a = 0; a < node.attributes.length; a++) {
      var at = node.attributes[a], name = at.name, val = at.value, key = single(val);
      if (/^on[a-z]+$/i.test(name) && key) {
        var fn = resolve(key, scope);
        if (typeof fn === 'function') { var id = 'h' + (self.seq++); self.handlers[id] = fn; el.setAttribute('data-dc-on-' + name.slice(2).toLowerCase(), id); }
        continue;
      }
      if (name === 'ref' && key) {
        var rf = resolve(key, scope);
        if (typeof rf === 'function') { var rid = 'r' + key; self.refs[rid] = rf; el.setAttribute('data-dc-ref', rid); }
        continue;
      }
      if (name.indexOf('hint-') === 0) continue;
      var v = interp(val, scope);
      if ((name === 'disabled' || name === 'checked' || name === 'hidden') && (v === 'false' || v === '')) continue;
      el.setAttribute(name, v);
    }
    var target = tag === 'template' ? el.content : el;
    for (var ch = node.firstChild; ch; ch = ch.nextSibling) self.buildNode(ch, scope, target);
    out.appendChild(el);
  };

  Mount.prototype.render = function () {
    var vals;
    try { vals = this.inst.renderVals() || {}; } catch (e) { console.error('renderVals', e); return; }
    this.handlers = {}; this.seq = 0;
    var frag = document.createElement('div');
    for (var n = this.tpl.firstChild; n; n = n.nextSibling) this.buildNode(n, vals, frag);
    var self = this;
    window.morphdom(this.root, frag, {
      childrenOnly: true,
      onBeforeElChildrenUpdated: function (fromEl) { return !fromEl.hasAttribute('data-dc-ref'); },
      onBeforeElUpdated: function (fromEl, toEl) {
        if (fromEl.hasAttribute('data-ll-cart-count')) return false;
        if (fromEl.tagName === 'VIDEO') return false;
        return true;
      }
    });
    var els = this.root.querySelectorAll('[data-dc-ref]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], fn = self.refs[el.getAttribute('data-dc-ref')];
      if (fn && self.refDone.get(el) !== fn) { self.refDone.set(el, fn); try { fn(el); } catch (e) { console.error('ref', e); } }
    }
  };

  window.DCLite = {
    mount: function (rootId) {
      var root = document.getElementById(rootId);
      if (!root) return;
      var assets = window.LL_ASSETS || {};
      var swap = function (s) { return s.replace(/@@A:([^@]+)@@/g, function (_, n) { return assets[n] || ''; }); };
      var tplEl = document.getElementById(rootId + '-tpl');
      var codeEl = document.getElementById(rootId + '-code');
      var html = swap(tplEl.innerHTML);
      var code = swap(codeEl.textContent);
      var Comp;
      try {
        Comp = new Function('DCLogic', code + '\n;return Component;')(function DCLogic() {});
      } catch (e) { console.error('Komponentfel', e); return; }
      new Mount(root, html, Comp);
    }
  };
})();

/* Varukorg: lägger till produkter i Shopifys varukorg och visar antalet i sidhuvudet. */
(function () {
  function money(n) { return n; }
  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var els = document.querySelectorAll('[data-ll-cart-count]');
      for (var i = 0; i < els.length; i++) els[i].textContent = c.item_count;
    }).catch(function () {});
  }
  // Tar en liten bild av kundens 3D-design (om sidan har en)
  function snapshot() {
    try {
      var c = document.querySelector('[data-dc-ref] canvas');
      if (!c || !c.width) return null;
      var w = 360, h = Math.round(w * c.height / c.width);
      var out = document.createElement('canvas'); out.width = w; out.height = h;
      var g = out.getContext('2d'); g.fillStyle = '#F3F3F4'; g.fillRect(0, 0, w, h);
      g.drawImage(c, 0, 0, w, h);
      return out.toDataURL('image/jpeg', 0.82);
    } catch (e) { return null; }
  }
  // Visar ögonblicksbilderna i varukorgen
  document.addEventListener('DOMContentLoaded', function () {
    var imgs = document.querySelectorAll('img[data-ll-key]');
    for (var i = 0; i < imgs.length; i++) {
      try { var d = localStorage.getItem('ll-bild-' + imgs[i].getAttribute('data-ll-key')); if (d) { imgs[i].src = d; imgs[i].style.objectFit = 'contain'; } } catch (e) {}
    }
  });

  // Visar en ruta när något har lagts i varukorgen
  var toastTimer = null;
  function hideToast() { var t = document.getElementById('ll-toast'); if (t) t.classList.remove('ll-toast--on'); }
  function showToast() {
    var t = document.getElementById('ll-toast');
    if (!t) {
      var css = document.createElement('style');
      css.textContent = '#ll-toast{position:fixed;z-index:200;right:20px;top:calc(var(--ll-head, 90px) + 12px);max-width:360px;width:calc(100% - 40px);opacity:0;transform:translateY(-8px);pointer-events:none;transition:opacity .2s ease,transform .2s ease;font-family:Inter,system-ui,sans-serif}' +
        '#ll-toast.ll-toast--on{opacity:1;transform:none;pointer-events:auto}' +
        '#ll-toast .ll-toast-in{background:#FFFFFF;border:2px solid #E8E1D6;border-radius:22px;box-shadow:0 18px 40px rgba(31,35,40,.18);padding:16px;display:flex;flex-direction:column;gap:12px}' +
        '#ll-toast b{font-size:1.05rem;color:#0B7A4B}' +
        '#ll-toast .ll-toast-btns{display:flex;gap:8px}' +
        '#ll-toast a,#ll-toast button{flex:1;display:inline-flex;align-items:center;justify-content:center;min-height:48px;border-radius:999px;font:inherit;font-weight:700;font-size:.95rem;text-decoration:none;cursor:pointer}' +
        '#ll-toast a{background:#1F2328;color:#FFFFFF;border:2px solid #1F2328}' +
        '#ll-toast button{background:#FFFFFF;color:#1F2328;border:2px solid #E8E1D6}' +
        '@media (max-width:860px){#ll-toast{top:auto;bottom:calc(84px + env(safe-area-inset-bottom));left:12px;right:12px;width:auto;max-width:none;transform:translateY(8px)}}' +
        '@media (prefers-reduced-motion: reduce){#ll-toast{transition:none}}';
      document.head.appendChild(css);
      t = document.createElement('div'); t.id = 'll-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<div class="ll-toast-in"><b>Tillagd i varukorgen ✓</b><div class="ll-toast-btns"><a href="/checkout">Gå till kassan</a><button type="button">Fortsätt handla</button></div></div>';
      t.querySelector('button').addEventListener('click', hideToast);
      document.body.appendChild(t);
    }
    t.classList.add('ll-toast--on');
    clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 7000);
  }
  window.LL_CART = {
    add: function (handle, optionValue, properties, qty) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Produkten "' + handle + '" finns inte i butiken.'); return r.json(); })
        .then(function (p) {
          var v = p.variants[0];
          if (optionValue) {
            for (var i = 0; i < p.variants.length; i++) {
              var x = p.variants[i];
              if (x.option1 === optionValue || x.title === optionValue) { v = x; break; }
            }
          }
          var props = {};
          Object.keys(properties || {}).forEach(function (k) { var val = properties[k]; if (val != null && val !== '') props[k] = String(val); });
          var snap = handle === 'nylonsnore' ? null : snapshot();
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: qty || 1, properties: props }] })
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Kunde inte lägga i varukorgen.'); });
            return r.json().then(function (res) {
              var items = (res && res.items) || [res];
              if (snap && items[0] && items[0].key) { try { localStorage.setItem('ll-bild-' + items[0].key, snap); } catch (e) {} }
            });
          });
        })
        .then(function () { updateCount(); showToast(); })
        .catch(function (e) { console.error(e); alert(e.message || 'Något gick fel. Försök igen.'); });
    },
    updateCount: updateCount
  };
  document.addEventListener('DOMContentLoaded', updateCount);
})();
